module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av252-2003374a455caa557b346e2509bec72b.jpg";